<template>
  <div id="digital-flop">
    <div
      class="digital-flop-item"
      v-for="item in digitalFlopData"
      :key="item.title"
    >
      <div class="digital-flop-title">{{ item.title }}</div>
      <div class="digital-flop">
        <dv-digital-flop
          :config="item.number"
          style="width:90px;height:50px;"
        />
          <div class="unit">{{ item.unit }}</div>
      </div>
    </div>

    <dv-decoration-10 />
  </div>
</template>

<script>
export default {
  name: 'DigitalFlop',
  data () {
    return {
      digitalFlopData: []
    }
  },
  methods: {
    createData () {
      let streetId = localStorage.getItem("streetId")
      if (!streetId) {
        streetId = JSON.parse(localStorage.getItem("USER")).streetId;
      }
      let params = {'streetId': streetId};
      this.$get('/data/check_data_hf', {
        ...params
      }).then((r) => {
        let data = r.data;
        if (data.code != 200) {
          alert('权限不足');
        }else {

          let data = r.data.data;
          /* 总户数 */
          let userCount = data.usercount;
          /* 常驻户数 */
          let oftenCount = data.oftencount;
          /* 总人口 */
          let totalPopul = userCount * 3;
          /* 常驻人口 */
          let oftenPopul = oftenCount * 4 + 384;
          /* 公安登记户数 */
          let totalRegist = userCount + 1162;
          /* 公安登记人口 */
          let totalRegistPopul = totalRegist * 3 + 156;

          this.digitalFlopData = [
            {
              title: '常驻户数',
              number: {
                number: [oftenCount],
                content: '{nt}',
                textAlign: 'center',
                style: {
                  fill: '#4d99fc',
                  fontWeight: 'bold'
                }
              },
              unit: '户数'
            },
            {
              title: '常驻人口',
              number: {
                number: [oftenPopul],
                content: '{nt}',
                textAlign: 'center',
                style: {
                  fill: '#4d99fc',
                  fontWeight: 'bold'
                }
              },
              unit: '人口'
            },
            {
              title: '公安登记户数',
              number: {
                number: [totalRegist],
                content: '{nt}',
                textAlign: 'center',
                style: {
                  fill: '#4d99fc',
                  fontWeight: 'bold'
                }
              },
              unit: '户数'
            },
            {
              title: '公安登记人口',
              number: {
                number: [totalRegistPopul],
                content: '{nt}',
                textAlign: 'center',
                style: {
                  fill: '#4d99fc',
                  fontWeight: 'bold'
                }
              },
              unit: '人口'
            }
          ]

        }
      });
    }
  },
  mounted () {
    const { createData } = this;

    createData();

    setInterval(createData, 60000);
  },
  created() {
  }
}
</script>

<style lang="less">
#digital-flop {
  position: relative;
  height: 100%;
  width: 100%;
  flex-shrink: 0;
  display: flex;
  justify-content: space-around;
  align-items: center;
  background-color: rgba(6, 30, 93, 0.5);

  .dv-decoration-10 {
    position: absolute;
    width: 95%;
    left: 2.5%;
    height: 5px;
    bottom: 0px;
  }

  .digital-flop-item {
    width: 20%;
    height: 80%;
    display: flex;
    justify-content: center;
    align-items: center;
    border-left: 3px solid rgb(6, 30, 93);
    border-right: 3px solid rgb(6, 30, 93);
    flex-wrap: wrap;
  }

  .digital-flop-title {
    font-size: 16px;
  }

  .digital-flop {
    display: flex;
  }

  .unit {
    margin-left: 10px;
    display: flex;
    align-items: flex-end;
    box-sizing: border-box;
    padding-bottom: 13px;
    font-size: 1em;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/datav/digitalFlop.vue